export { ImageContent1Up, type ImageContent1UpProps } from './ImageContent1Up';
export { imageContent1UpSchema } from './schema';
